module.exports = __webpack_public_path__ + "static/media/Oliva-Serif-Alts-2.510e5ce6.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Oliva-Serif-Alts-2.eot
// module id = 2951
// module chunks = 68